export default "__VITE_ASSET__c8UijEle__"